import React, {useEffect, useMemo} from "react";
import ReportCardTooltip from "./report-card-tooltip.jsx";
import {FaExclamationTriangle} from "react-icons/fa";
import ReportUtils from "../../../../../../utils/report-utils.js";

const labels = [
  "Apreensões realizadas",
  "Apreensões por plantão",
  "Apreensões em flagrante",
];


const ApprehensionCards = ({data, isLeader}) => {
  const reportName = isLeader ? "Apreensões dos subordinados" : "Apreensões"

  useEffect(() => {
    const rows = [];
    rows.push(data.total_apprehension ?? 0);
    rows.push(data.apprehension_avg ?? 0);
    rows.push(data.apprehencion_flagrant ?? 0);

    ReportUtils.createExportableTable(labels, rows, reportName);
  }, [data]);

  return(
    <>
      <div className="report-divisor">
        <span className="divisor-title">{reportName.toUpperCase()}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[0]}</h3><h2>{data.total_apprehension ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center" title="Gerados a partir de despachos">
            <div className="box">
              <h3>{labels[1]}</h3><h2>{data.apprehension_avg ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[2]}</h3><h2>{data.apprehencion_flagrant ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="chart-divisor"></div>
    </>
  )
}

export default ApprehensionCards;